import React from 'react';
import { Tooltip, Typography } from '@duxton-web/ui';

import JSONWrapper from './json-wrapper';
import { ChangelogDiffType } from '@/common/const';
import { Changelog } from '@/common/dto/changelog';
import { VariableState } from '@/constants';
import VariableDiffWrapper from '@/features/changelog/variable-diff/wrapper';
import { getVariableDiff } from '@/features/variable/utils';
import { isFieldChanged } from '@/utils/difference';

interface VariableDiffProps {
  changelog: Changelog;
}

const VariableDiff = ({ changelog }: VariableDiffProps) => {
  const diff = getVariableDiff(
    changelog?.old_variable,
    changelog?.new_variable,
  );
  const variableStateChanged = isFieldChanged(diff, 'state');

  if (variableStateChanged && changelog?.old_variable?.state)
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          borderRadius: 16,
          backgroundColor: '#F5F5F5',
          border: '1px solid #DBDBDB',
          padding: 16,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3 8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16V8ZM8 5C6.34315 5 5 6.34315 5 8V12H9C9.55228 12 9.97928 12.4745 10.2445 12.959C10.5841 13.5793 11.2429 14 12 14C12.7571 14 13.4159 13.5793 13.7555 12.959C14.0207 12.4745 14.4477 12 15 12H19V8C19 6.34315 17.6569 5 16 5H8Z"
              fill="#1A1A1A"
            />
          </svg>
          <Tooltip>
            <Typography.Text>
              The variable has been
              <Typography.Text strong>
                {` ${
                  changelog?.new_variable?.state === VariableState.ARCHIVED
                    ? 'archived'
                    : 'unarchived'
                } `}
              </Typography.Text>
              in this change
            </Typography.Text>
          </Tooltip>
        </div>
      </div>
    );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div
        className="changelog-item-variable-diff"
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
        }}
      >
        <VariableDiffWrapper
          data-testid="variable-diff-current"
          diffType={ChangelogDiffType.BEFORE}
          previousVariable={changelog?.new_variable}
          currentVariable={changelog?.old_variable}
          style={{
            width: '49%',
          }}
        />
        <VariableDiffWrapper
          data-testid="variable-diff-previous"
          diffType={ChangelogDiffType.AFTER}
          previousVariable={changelog?.old_variable}
          currentVariable={changelog?.new_variable}
          style={{
            width: '49%',
          }}
        />
      </div>
      <JSONWrapper
        previousVariable={changelog?.old_variable}
        currentVariable={changelog?.new_variable}
      />
    </div>
  );
};

export default VariableDiff;
